import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutAlignRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutAlignRight"><Path d="M3.5 3.5L3.5 3L3 3V3.5L3.5 3.5ZM20.5 3.5H21V3H20.5V3.5ZM20.5 20.5V21H21V20.5H20.5ZM3.5 20.5H3L3 21H3.5V20.5ZM16 16.5V17H17V16.5H16ZM17 7.5V7H16V7.5H17ZM3.5 4L20.5 4V3L3.5 3L3.5 4ZM20 3.5V20.5H21V3.5H20ZM20.5 20H3.5V21H20.5V20ZM4 20.5L4 3.5L3 3.5L3 20.5H4ZM17 16.5V7.5H16V16.5H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutAlignRight;
